import { Controller } from "@hotwired/stimulus"

class NotificationsCenter extends Controller {
  static targets = ["documentTargetGroup", "documentTargetInput"]

  updateOptgroup() {
    const optgroupInput = this.documentTargetGroupTarget.querySelector("input")
    const optionsChecked = this._getOptionsChecked()
    const optionsCount = this._getOptionsCount()
    if (optionsChecked.length === 0) {
      optgroupInput.checked = false
      optgroupInput.indeterminate = false
    } else if (optionsChecked.length === optionsCount) {
      optgroupInput.checked = true
      optgroupInput.indeterminate = false
    } else {
      optgroupInput.checked = false
      optgroupInput.indeterminate = true
    }
  }

  updateOptions() {
    const optionsChecked = this._getOptionsChecked()
    const optionsCount = this._getOptionsCount()

    if (optionsChecked.length === optionsCount) {
      this.documentTargetInputTargets.forEach(input => {
        input.checked = false
      })
    } else {
      this.documentTargetInputTargets.forEach(input => {
        input.checked = true
      })
    }
  }

  _getOptionsChecked() {
    return this.documentTargetInputTargets.filter(input => input.checked)
  }

  _getOptionsCount() {
    return this.documentTargetInputTargets.length
  }
}

export { NotificationsCenter }
